import * as Icons from "@/components/Icons";
import { List, NavCollapse, NavLink, NavLinkWithSubmenu } from "./utlis";
import { usePanelUser, useTypeUser } from "@/hooks/auth";
import {
  ChevronLeft,
  ChevronRight,
  GraduationCap,
  Award,
  Building2,
  Store,
  Percent,
  Users2,
  UserPlus,
  UserCheck,
  Package,
  PackageSearch,
  Users,
  Box,
  User,
  ShoppingCart,
  PlusCircle,
  LocateIcon,
  ClipboardCheck,
  Receipt,
  CreditCard,
  BanknoteIcon,
  ArrowLeftRight,
  Bell,
  UsersRound,
  Settings2,
  FileText,
  Boxes,
  ShoppingBag,
  RotateCcw,
  History,
  TrendingUp,
  QrCode,
  Target,
  FileEdit,
  FolderOpen,
  ListChecks,
  Stethoscope,
  Wrench,
  UserCog,
  ScrollText,
  Trophy,
  Database,
  Layers,
  PenLine,
  Wallet,
} from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Link } from "react-router-dom";
import Logo from "@/components/Logo";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { colors } from "@/utils/colors";
import { If } from "../If";
import { usePermissions } from "@/hooks/usePermissions";
import { PERMISSIONS } from "@/constants/permissions";
import { useSellerUsesBleed } from "@/hooks/useSellerUsesBleed";

export function NavbarList({ collapsed }: { collapsed?: boolean }) {
  const auth = usePanelUser();
  const authOnlyClient = useTypeUser(2);
  const authClientAndSeller = useTypeUser(2, 3);
  const authSeller = useTypeUser(3);
  const authAllUserTypes = useTypeUser(2, 3, 4);
  const authClientAndUnityResponsible = useTypeUser(2, 4);
  // Banco de Bolões (LOT-62): vendedor e estoquista nunca veem, mesmo que hasPermission devolva true para o tipo deles
  const authGameBankUsers = useTypeUser(1, 2, 4);
  // const authClientAndUnityResponsibleAndStockist = useTypeUser(2, 4, 5);
  const authOnlyUnityReponsible = useTypeUser(4);
  const { hasPermission } = usePermissions();
  // Vendedor de unidade sem sangria não vê o menu Sangrias
  const sellerUsesBleed = useSellerUsesBleed();

  return (
    <ScrollArea className="h-full w-full" classBar="w-2">
      <div className="flex flex-col gap-2 pl-5 py-2">
        <List>
          {/* Dashboard */}
          <NavLink to="/dashboard" refs={["/"]} collapsed={collapsed}>
            <Icons.CharBar />
            Dashboard
          </NavLink>

          {/* Empresas - apenas admin */}
          {auth(() => (
            <NavLink to="/empresas" refs={["/empresas"]} collapsed={collapsed}>
              <GraduationCap />
              Empresas
            </NavLink>
          ))}

          {/* Correção de Balanços - ferramenta emergencial, apenas Super Admin */}
          {auth(() => (
            <NavLink
              to="/correcao-de-balancos"
              refs={["/correcao-de-balancos"]}
              collapsed={collapsed}
            >
              <Wrench />
              Correção de Balanços
            </NavLink>
          ))}

          {/* Logs de Ações - Super Admin */}
          {auth(() => (
            <NavLink
              to="/logs-de-acoes"
              refs={["/logs-de-acoes"]}
              collapsed={collapsed}
            >
              <ScrollText />
              Logs de Ações
            </NavLink>
          ))}

          {/* Acesso como usuário - apenas Super Admin */}
          {auth(() => (
            <NavLink
              to="/acessar-como-usuario"
              refs={["/acessar-como-usuario"]}
              collapsed={collapsed}
            >
              <UserCog />
              Acesso como Usuário
            </NavLink>
          ))}

          {/* Estoque com submenu */}
          <If
            condition={
              hasPermission("view-distribution-unity") ||
              hasPermission("view-distribution-seller")
            }
          >
            <NavLinkWithSubmenu
              title="Estoque"
              to="/estoque"
              refs={["/estoque"]}
              icon={<Box />}
              collapsed={collapsed}
            >
              <NavLink to="/estoque-vendedores" refs={["/estoque-vendedores"]} collapsed={collapsed}>
                <Box />
                Estoque por Vendedor
              </NavLink>
              <NavLink to="/estoque-unidades" refs={["/estoque-unidades"]} collapsed={collapsed}>
                <Box />
                Estoque por Unidade
              </NavLink>
            </NavLinkWithSubmenu>
          </If>

          {/* Distribuição com submenu */}
            <If condition={hasPermission("view-distributions-list")}>
              <NavLinkWithSubmenu
                title="Distribuição"
                to="/distribuicoes"
                refs={["/distribuicoes"]}
                icon={<Package />}
                collapsed={collapsed}
              >
                {authOnlyUnityReponsible(() => (
                  <>
                    <NavLink
                      to="/pendentes-distribuicoes"
                      refs={["/pendentes-distribuicoes"]}
                      collapsed={collapsed}
                    >
                      <Package />
                      Distribuições Recebidas
                    </NavLink>
                    <NavLink
                      to="/distribuicoes-entre-unidades"
                      refs={["/distribuicoes-entre-unidades"]}
                      collapsed={collapsed}
                    >
                      <Package />
                      Entre Unidades
                    </NavLink>
                  </>
                ))}
                {authSeller(() => (
                  <>
                    <NavLink
                      to="/pendentes-distribuicoes-vendedores"
                      refs={["/pendentes-distribuicoes-vendedores"]}
                      collapsed={collapsed}
                    >
                      <Package />
                      Minhas Distribuições
                    </NavLink>
                    <NavLink
                      to="/distribuicoes-entre-vendedores"
                      refs={["/distribuicoes-entre-vendedores"]}
                      collapsed={collapsed}
                    >
                      <Package />
                      Entre Vendedores
                    </NavLink>
                    <NavLinkWithSubmenu
                      title="Vendedor para Unidade"
                      to="/distribuicoes-vendedor-para-unidade"
                      refs={["/distribuicoes-vendedor-para-unidade"]}
                      icon={<Package />}
                      collapsed={collapsed}
                    >
                      <NavLink
                        to="/distribuicoes-vendedor-para-unidade"
                        refs={["/distribuicoes-vendedor-para-unidade$"]}
                        collapsed={collapsed}
                      >
                        <Package />
                        Registro
                      </NavLink>
                      <NavLink
                        to="/distribuicoes-vendedor-para-unidade/historico"
                        refs={["/distribuicoes-vendedor-para-unidade/historico"]}
                        collapsed={collapsed}
                      >
                        <History />
                        Histórico
                      </NavLink>
                    </NavLinkWithSubmenu>
                  </>
                ))}
                {authClientAndUnityResponsible(() => (
                  <>
                    <NavLink
                      to="/historico-distribuicoes"
                      refs={["/historico-distribuicoes"]}
                      collapsed={collapsed}
                    >
                      <History />
                      Histórico de Distribuições
                    </NavLink>
                    <NavLink
                      to="/historico-acoes-distribuicao"
                      refs={["/historico-acoes-distribuicao"]}
                      collapsed={collapsed}
                    >
                      <History />
                      Histórico de Ações
                    </NavLink>
                    <NavLink
                      to="/distribuicoes-vendedor-para-unidade/historico"
                      refs={["/distribuicoes-vendedor-para-unidade/historico"]}
                      collapsed={collapsed}
                    >
                      <History />
                      Recebidos de Vendedores
                    </NavLink>
                  </>
                ))}
              </NavLinkWithSubmenu>
            </If>

          {/* Banco de Bolões (LOT-62): menu próprio, fora de Concursos */}
          {authGameBankUsers(() => (
            <If condition={hasPermission(PERMISSIONS.VIEW_GAME_BANK)}>
              <NavLinkWithSubmenu
                title="Banco de Bolões"
                to="/banco-de-boloes"
                refs={["/banco-de-boloes"]}
                icon={<Database />}
                collapsed={collapsed}
              >
                <NavLink to="/banco-de-boloes" refs={["/banco-de-boloes"]} collapsed={collapsed}>
                  <Layers />
                  Banco de Jogos
                </NavLink>
                <If condition={hasPermission(PERMISSIONS.VIEW_GAME_SELECTIONS)}>
                  <NavLink to="/formador-de-boloes" refs={["/formador-de-boloes"]} collapsed={collapsed}>
                    <ListChecks />
                    Formador de Bolões
                  </NavLink>
                </If>
              </NavLinkWithSubmenu>
            </If>
          ))}

          {/* Concursos com submenu */}
          {authClientAndUnityResponsible(() => (
            <If condition={hasPermission("view-contest-list")}>
              <NavLinkWithSubmenu
                title="Concursos"
                to="/concursos"
                refs={["/concursos"]}
                icon={<Award />}
                collapsed={collapsed}
              >
                <If condition={hasPermission("view-products-list")}>
                  <NavLink to="/produtos" refs={["/produtos"]} collapsed={collapsed}>
                    <PackageSearch />
                    Produtos
                  </NavLink>
                </If>
                <If condition={hasPermission("view-lotteries-list")}>
                  <NavLink to="/loterias" refs={["/loterias"]} collapsed={collapsed}>
                    <Package />
                    Loterias
                  </NavLink>
                </If>
                <If condition={hasPermission("view-discount-types-list")}>
                  <NavLink to="/tipos-de-descontos" refs={["/tipos-de-descontos"]} collapsed={collapsed}>
                    <Percent />
                    Tipos de descontos
                  </NavLink>
                </If>
                <NavLink to="/sobras" refs={["/sobras"]} collapsed={collapsed}>
                  <Boxes />
                  Sobras
                </NavLink>
                <If
                  condition={
                    hasPermission("view-sales-calculation-list") ||
                    hasPermission("view-awards-list") ||
                    hasPermission(PERMISSIONS.VIEW_TOTAL_PRIZES)
                  }
                >
                  <If condition={hasPermission("view-sales-calculation-list")}>
                    <NavLink to="/apuracao" refs={["/apuracao"]} collapsed={collapsed}>
                      <ClipboardCheck />
                      Apuração
                    </NavLink>
                  </If>
                  <If condition={hasPermission("view-awards-list")}>
                    <NavLink to="/premios-apuracao" refs={["/premios-apuracao"]} collapsed={collapsed}>
                      <ClipboardCheck />
                      Lista de Prêmios
                    </NavLink>
                  </If>
                  <If condition={hasPermission(PERMISSIONS.VIEW_TOTAL_PRIZES)}>
                    <NavLink to="/premiacoes-totais" refs={["/premiacoes-totais"]} collapsed={collapsed}>
                      <Trophy />
                      Premiações Totais
                    </NavLink>
                  </If>
                </If>
              </NavLinkWithSubmenu>
            </If>
          ))}

          {/* Vendas com submenu */}
          {authAllUserTypes(() => (
            <If condition={hasPermission("view-sales-list")}>
              <NavLinkWithSubmenu
                title="Vendas"
                to="/vendas"
                refs={["/vendas"]}
                icon={<ShoppingCart />}
                collapsed={collapsed}
              >
                {authClientAndSeller(() => (
                  <If condition={hasPermission("create-sales")}>
                    <NavLink to="/criar-venda" refs={["/criar-venda"]} collapsed={collapsed}>
                      <PlusCircle />
                      Criar Venda
                    </NavLink>
                  </If>
                ))}
                <If condition={hasPermission("view-pre-sales-list")}>
                  <NavLink to="/fila-pre-vendas" refs={["/fila-pre-vendas"]} collapsed={collapsed}>
                    <ListChecks />
                    Fila Pré-vendas
                  </NavLink>
                </If>
                {authClientAndUnityResponsible(() => (
                  <If condition={hasPermission("view-sales-marketplace-list")}>
                    <NavLink to="/marketplace-vendas" refs={["/marketplace"]} collapsed={collapsed}>
                      <ShoppingBag />
                      Marketplace
                    </NavLink>
                  </If>
                ))}
                <If condition={hasPermission("view-sedex-tab")}>
                  <NavLink to="/sedex" refs={["/sedex"]} collapsed={collapsed}>
                    <Package />
                    Sedex
                  </NavLink>
                </If>
                <If condition={hasPermission("view-sales-list")}>
                  <NavLink to="/pix-gerados" refs={["/pix-gerados"]} collapsed={collapsed}>
                    <QrCode />
                    Pix Gerados
                  </NavLink>
                </If>
                {authClientAndUnityResponsible(() => (
                  <If condition={hasPermission("view-circuit-route-list")}>
                    <NavLink to="/rotas" refs={["/rotas"]} collapsed={collapsed}>
                      <LocateIcon />
                      Rotas (Circuit)
                    </NavLink>
                  </If>
                ))}
                <NavLink to="/devolucoes" refs={["/devolucoes"]} collapsed={collapsed}>
                  <RotateCcw />
                  Devoluções
                </NavLink>
                <If condition={hasPermission(PERMISSIONS.VIEW_BLEED_LIST) && sellerUsesBleed === true}>
                  <NavLink to="/sangrias" refs={["/sangrias"]} collapsed={collapsed}>
                    <BanknoteIcon />
                    Sangrias
                  </NavLink>
                </If>
                {authClientAndSeller(() => (
                  <If condition={hasPermission("view-service-scripts-list")}>
                    <NavLink to="/scripts-atendimento" refs={["/scripts-atendimento"]} collapsed={collapsed}>
                      <FileText />
                      Scripts de Atendimento
                    </NavLink>
                  </If>
                ))}
                <If condition={hasPermission("view-sale-change-requests")}>
                  <NavLink to="/solicitacoes-alteracao" refs={["/solicitacoes-alteracao"]} collapsed={collapsed}>
                    <FileEdit />
                    Solicitações
                  </NavLink>
                </If>
                <If condition={hasPermission("view-purchases-by-client-list")}>
                  <NavLink to="/compras-de-clientes" refs={["/compras-de-clientes"]} collapsed={collapsed}>
                    <ClipboardCheck />
                    Compras por cliente
                  </NavLink>
                </If>
                <If condition={hasPermission(PERMISSIONS.VIEW_ENDORSEMENT_REQUESTS)}>
                  <NavLink to="/endossamento" refs={["/endossamento"]} collapsed={collapsed}>
                    <PenLine />
                    Endossamento
                  </NavLink>
                </If>
                <If condition={hasPermission(PERMISSIONS.VIEW_CLIENT_RESULTS)}>
                  <NavLink to="/resultado-clientes" refs={["/resultado-clientes"]} collapsed={collapsed}>
                    <Trophy />
                    Resultado Clientes
                  </NavLink>
                </If>
                {authOnlyClient(() => (
                  <If condition={hasPermission("view-goals-list")}>
                    <NavLink to="/metas" refs={["/metas"]} collapsed={collapsed}>
                      <Target />
                      Metas
                    </NavLink>
                  </If>
                ))}
              </NavLinkWithSubmenu>
            </If>
          ))}

          {/* Cadastros - dropdown sem link principal */}
          {authClientAndUnityResponsible(() => (
            <NavCollapse
              title="Cadastros"
              icon={<FolderOpen />}
              collapsed={collapsed}
            >
              <If condition={hasPermission("view-units-list")}>
                <NavLink to="/unidades" refs={["/unidades"]} collapsed={collapsed}>
                  <Building2 />
                  Unidades
                </NavLink>
              </If>
              {/* Estabelecimentos: oculto por não estar mais em uso, manter código para possível reativação futura */}
              {false && (
                <If condition={hasPermission("view-establishments-list")}>
                  <NavLink to="/estabelecimentos" refs={["/estabelecimentos"]} collapsed={collapsed}>
                    <Store />
                    Estabelecimentos
                  </NavLink>
                </If>
              )}
              <If condition={hasPermission("view-sellers-list")}>
                <NavLink to="/vendedores" refs={["/vendedores"]} collapsed={collapsed}>
                  <UserCheck />
                  Vendedores
                </NavLink>
              </If>
              <If condition={hasPermission("view-sellers-list")}>
                <NavLink to="/vendedores-historico" refs={["/vendedores-historico"]} collapsed={collapsed}>
                  <ClipboardCheck />
                  Histórico de Vendas
                </NavLink>
              </If>
              <If condition={hasPermission("show-unit-responsible")}>
                <NavLink to="/estoquistas" refs={["/estoquistas"]} collapsed={collapsed}>
                  <UserCheck />
                  Estoquistas
                </NavLink>
              </If>
              <If condition={hasPermission("view-clients-list")}>
                <NavLink to="/clientes" refs={["/clientes"]} collapsed={collapsed}>
                  <Users />
                  Clientes
                </NavLink>
              </If>
              <If condition={hasPermission("view-client-categories-list")}>
                <NavLink to="/categoria-de-clientes" refs={["/categoria-de-clientes"]} collapsed={collapsed}>
                  <Users2 />
                  Categoria de clientes
                </NavLink>
              </If>
              <If condition={hasPermission("view-client-sources-list")}>
                <NavLink to="/origens-de-clientes" refs={["/origens-de-clientes"]} collapsed={collapsed}>
                  <UserPlus />
                  Origens de clientes
                </NavLink>
              </If>
            </NavCollapse>
          ))}

          {/* Clientes - apenas para vendedor e responsável de unidade (se não for client) */}
          {authSeller(() => (
            <If condition={hasPermission("view-clients-list")}>
              <NavLink to="/clientes" refs={["/clientes"]} collapsed={collapsed}>
                <Users />
                Clientes
              </NavLink>
            </If>
          ))}

          {/* Apuração - vendedor só consulta (as ações de apurar ficam ocultas na tela) */}
          {authSeller(() => (
            <If condition={hasPermission("view-sales-calculation-list")}>
              <NavLink to="/apuracao" refs={["/apuracao"]} collapsed={collapsed}>
                <ClipboardCheck />
                Apuração
              </NavLink>
            </If>
          ))}

          {/* CRM - oculto temporariamente, ainda não será usado */}
          {false && authAllUserTypes(() => (
            <If condition={hasPermission("view-leads-management")}>
              <NavLinkWithSubmenu
                title="CRM"
                to="/crm"
                refs={["/crm$", "/crm/kanban"]}
                icon={<UsersRound />}
                collapsed={collapsed}
              >
                <If condition={hasPermission("view-lead-tracking-list")}>
                  <NavLink to="/rastreio-leads" refs={["/rastreio-leads"]} collapsed={collapsed}>
                    <UsersRound />
                    Rastreio de Leads
                  </NavLink>
                </If>
                {authClientAndUnityResponsible(() => (
                  <If condition={hasPermission("view-configuration-kanban-list")}>
                    <NavLink to="/crm/settings" refs={["/crm/settings"]} collapsed={collapsed}>
                      <Settings2 />
                      Configurar Kanban
                    </NavLink>
                  </If>
                ))}
              </NavLinkWithSubmenu>
            </If>
          ))}

          {/* Financeiro - dropdown */}
          {authClientAndUnityResponsible(() => (
            <NavCollapse
              title="Financeiro"
              icon={<BanknoteIcon />}
              collapsed={collapsed}
            >
              <div style={{ maxHeight: 400, overflowY: 'auto' }}>
                <If condition={hasPermission("view-contest-profit-list")}>
                  <NavLink to="/lucros-concurso" refs={["/lucros-concurso"]} collapsed={collapsed}>
                    <TrendingUp />
                    Lucros do Concurso
                  </NavLink>
                </If>
                <If condition={hasPermission("view-expense-categories-list")}>
                  <NavLink to="/categorias-de-despesas" refs={["/categorias-de-despesas"]} collapsed={collapsed}>
                    <Receipt />
                    Categorias de Despesas
                  </NavLink>
                </If>
                <If condition={hasPermission("view-expense-types-list")}>
                  <NavLink to="/tipos-de-despesas" refs={["/tipos-de-despesas"]} collapsed={collapsed}>
                    <CreditCard />
                    Tipos de Despesas
                  </NavLink>
                </If>
                <If condition={hasPermission("view-income-categories-list")}>
                  <NavLink to="/categorias-de-receitas" refs={["/categorias-de-receitas"]} collapsed={collapsed}>
                    <Receipt />
                    Categorias de Receitas
                  </NavLink>
                </If>
                <If condition={hasPermission("view-income-types-list")}>
                  <NavLink to="/tipos-de-receitas" refs={["/tipos-de-receitas"]} collapsed={collapsed}>
                    <Receipt />
                    Tipos de Receitas
                  </NavLink>
                </If>
                <If condition={hasPermission("view-transactions-list")}>
                  <NavLink to="/contas-a-pagar" refs={["/contas-a-pagar"]} collapsed={collapsed}>
                    <BanknoteIcon />
                    Transações Financeiras
                  </NavLink>
                </If>
                <If condition={hasPermission("view-reconciliations-list")}>
                  <NavLink to="/reconciliacao-financeira" refs={["/reconciliacao-financeira"]} collapsed={collapsed}>
                    <BanknoteIcon />
                    Conciliação Financeira
                  </NavLink>
                </If>
                <If condition={hasPermission("view-cash-flow")}>
                  <NavLink to="/fluxo-de-caixa" refs={["/fluxo-de-caixa"]} collapsed={collapsed}>
                    <ArrowLeftRight />
                    Fluxo de Caixa
                  </NavLink>
                </If>
                <If condition={hasPermission("view-bank-accounts-list")}>
                  <NavLink to="/contas-bancarias" refs={["/contas-bancarias"]} collapsed={collapsed}>
                    <BanknoteIcon />
                    Contas Bancárias
                  </NavLink>
                </If>
                <NavLink to="/operacoes-carteira" refs={["/operacoes-carteira"]} collapsed={collapsed}>
                  <Wallet />
                  Operações
                </NavLink>
                <If condition={hasPermission("view-reports-list")}>
                  <NavLink to="/relatorios" refs={["/relatorios"]} collapsed={collapsed}>
                    <FileText />
                    Relatórios
                  </NavLink>
                </If>
              </div>
            </NavCollapse>
          ))}

          {/* Premiação - com link principal para Acompanhamentos */}
          {authClientAndUnityResponsible(() => (
            <If condition={hasPermission("view-commission-ranges-list") || hasPermission("view-commission-tracking-list")}>
              <NavLinkWithSubmenu
                title="Premiação"
                to="/acompanhamentos-comissoes"
                refs={["/acompanhamentos-comissoes", "/faixas-de-comissao"]}
                icon={<BanknoteIcon />}
                collapsed={collapsed}
              >
                <NavLink to="/faixas-de-comissao" refs={["/faixas-de-comissao"]} collapsed={collapsed}>
                  <ListChecks />
                  Regras Premiação
                </NavLink>
              </NavLinkWithSubmenu>
            </If>
          ))}

          {/* Ferramentas de PDF (LOT-60): qualquer usuário autenticado */}
          <NavLink to="/ferramentas-pdf" refs={["/ferramentas-pdf"]} collapsed={collapsed}>
            <FileText />
            Ferramentas de PDF
          </NavLink>

          {/* Configurações - dropdown */}
          {authClientAndUnityResponsible(() => (
            <NavCollapse
              title="Configurações"
              icon={<Settings2 />}
              collapsed={collapsed}
            >
              <If condition={hasPermission("view-positions-list")}>
                <NavLink to="/cargos" refs={["/cargos"]} collapsed={collapsed}>
                  <User />
                  Cargos
                </NavLink>
              </If>
              <If condition={hasPermission("view-notifications-list")}>
                <NavLink to="/notifications" refs={["/notifications"]} collapsed={collapsed}>
                  <Bell />
                  Notificações
                </NavLink>
              </If>
              <If condition={hasPermission("view-users-list")}>
                <NavLink to="/usuarios" collapsed={collapsed}>
                  <Users />
                  Usuários
                </NavLink>
              </If>
              {authOnlyClient(() => (
                <NavLink to="/configuracoes" refs={["/configuracoes"]} collapsed={collapsed}>
                  <Settings2 />
                  Configurações do Sistema
                </NavLink>
              ))}
              {/* Acesso como usuário - Admin do Tenant com a permissão */}
              {authOnlyClient(() => (
                <If condition={hasPermission(PERMISSIONS.IMPERSONATE_USERS)}>
                  <NavLink
                    to="/acessar-como-usuario"
                    refs={["/acessar-como-usuario"]}
                    collapsed={collapsed}
                  >
                    <UserCog />
                    Acesso como Usuário
                  </NavLink>
                </If>
              ))}
              {/* Correção de Balanços - Admin do Tenant com a permissão */}
              {authOnlyClient(() => (
                <If condition={hasPermission(PERMISSIONS.MANAGE_BALANCE_ADJUSTMENTS)}>
                  <NavLink
                    to="/correcao-de-balancos"
                    refs={["/correcao-de-balancos"]}
                    collapsed={collapsed}
                  >
                    <Wrench />
                    Correção de Balanços
                  </NavLink>
                </If>
              ))}
              {/* Normalização de Vendas - Admin do Tenant com a permissão */}
              {authOnlyClient(() => (
                <If condition={hasPermission(PERMISSIONS.MANAGE_SALE_NORMALIZATION)}>
                  <NavLink
                    to="/normalizacao-de-vendas"
                    refs={["/normalizacao-de-vendas"]}
                    collapsed={collapsed}
                  >
                    <Stethoscope />
                    Normalização de Vendas
                  </NavLink>
                </If>
              ))}
              {/* Logs de Ações - Admin do Tenant com a permissão */}
              {authOnlyClient(() => (
                <If condition={hasPermission(PERMISSIONS.VIEW_ACTION_LOGS)}>
                  <NavLink
                    to="/logs-de-acoes"
                    refs={["/logs-de-acoes"]}
                    collapsed={collapsed}
                  >
                    <ScrollText />
                    Logs de Ações
                  </NavLink>
                </If>
              ))}
            </NavCollapse>
          ))}
        </List>
      </div>
    </ScrollArea>
  );
}

export default function Navbar() {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div
      className={cn(
        "group/nav h-full max-h-full hidden sm:block relative transition-all duration-300 shadow",
        `dark:bg-[#2c2c2c] dark:text-[#FED06C]`,
        colors.bg_primary,
        collapsed ? "w-20" : "w-nav"
      )}
      data-mode="auto"
    >
      <div className="flex flex-col inset-0 absolute w-full">
        <div
          className={cn(
            "flex items-center justify-between my-4",
            collapsed ? "" : "pl-5"
          )}
        >
          <Link to="/" className="rounded">
            <Logo className={cn(collapsed ? "w-0" : "w-full")} />
          </Link>
          <Button
            variant="ghost"
            size="icon"
            className={cn(
              "text-primary hover:bg-zinc-100 bg-zinc-100 shadow-inner rounded-none rounded-s translate-x-0.5",
              ``,
              "dark:bg-[#202020] dark:text-[#FF8500]",
              collapsed
                ? "shadow-inner rounded-none rounded-s translate-x-0.5 w-3/4"
                : ""
            )}
            onClick={() => setCollapsed(!collapsed)}
          >
            {collapsed ? <ChevronRight /> : <ChevronLeft />}
          </Button>
        </div>
        <NavbarList collapsed={collapsed} />
      </div>
    </div>
  );
}
